// extracted by mini-css-extract-plugin
module.exports = {"header":"TabBar_header__IXJSQ","active":"TabBar_active__wejqY","unactive":"TabBar_unactive__EmhDY","WhiteText":"TabBar_WhiteText__q2N26","badge":"TabBar_badge__61CMP"};